import { FlowItem } from './flow-item';

export interface FlowExecution {
    state: ExecutionState;
    current: FlowItem;
    startNode: FlowItem;
}

export enum ExecutionState {
    Idle = 'idle',
    Running = 'running',
    Stopped = 'stopped',
    Finished = 'finished'
}